
import React from 'react';
import { FileSearch, Target, Users, TrendingUp, Shield, Recycle } from 'lucide-react';

const RSEServices = () => {
  const services = [
    {
      icon: FileSearch,
      title: "Audit et diagnostic",
      description: "Analyse complète de votre gestion actuelle des déchets",
      color: "from-blue-500 to-blue-600"
    },
    {
      icon: Target,
      title: "Stratégie personnalisée", 
      description: "Élaboration d'une stratégie de réduction et valorisation",
      color: "from-fabre-green to-fabre-teal"
    },
    {
      icon: Users,
      title: "Formation équipes",
      description: "Sensibilisation et formation de votre personnel",
      color: "from-purple-500 to-purple-600"
    },
    {
      icon: TrendingUp,
      title: "Reporting RSE",
      description: "Indicateurs de performance et suivi des objectifs",
      color: "from-orange-500 to-orange-600"
    },
    {
      icon: Shield,
      title: "Conformité réglementaire",
      description: "Respect des normes et réglementations en vigueur",
      color: "from-red-500 to-red-600"
    },
    {
      icon: Recycle,
      title: "Valorisation maximale",
      description: "Optimisation des taux de recyclage et valorisation",
      color: "from-green-500 to-green-600"
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-heading font-bold mb-4 text-fabre-gray">
            Nos Services RSE
          </h2>
          <div className="w-24 h-1.5 bg-gradient-to-r from-fabre-green to-fabre-teal mx-auto mb-6 rounded-full"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Solutions complètes pour votre démarche de responsabilité sociétale
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 p-6 border border-gray-100 hover:border-fabre-green/30 hover:-translate-y-1"
            >
              <div className="text-center">
                <div className={`w-16 h-16 bg-gradient-to-r ${service.color} rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <service.icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-lg font-bold text-fabre-gray mb-3 group-hover:text-fabre-green transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RSEServices;
